import { Stack, Button, Box, LinearProgress, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { useGetProductIntakesQuery } from "src/api/services/intakesApi";
import { MatchParam } from "src/constants/matches";
import { useMemo } from "react";
import DataTable from "src/components/DataTable";
import { useColumns } from "./useColumns";
import { useManageModal } from "src/hooks/useManageModal";
import AddNewProductIntake from "src/components/Modals/AddNewProductIntake";

const ProductIntakes = () => {
  const [open, { handleClose, handleOpen }] = useManageModal();
  const { productId } = useParams<MatchParam<"PRODUCT_ID">>();
  const { data: intakes = [], isFetching } = useGetProductIntakesQuery(
    productId
      ? {
          productId,
        }
      : skipToken,
  );
  const columns = useColumns();
  const height = useMemo(() => window.innerHeight - 104 - 64 - 34, []);

  return (
    <Stack gap={2} sx={{ width: "100%", minWidth: 0 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h5">Intakes</Typography>
        <Button onClick={handleOpen}>+ Add Intake</Button>
      </Stack>
      <Stack gap={0} sx={{ width: "100%", minWidth: 0 }}>
        <Box height={4}>{isFetching ? <LinearProgress /> : null}</Box>
        <DataTable
          data={intakes}
          columns={columns}
          height={height}
          primaryKey="id"
        />
      </Stack>
      {productId != null ? (
        <AddNewProductIntake
          open={open}
          onClose={handleClose}
          productSlug={productId}
        />
      ) : null}
    </Stack>
  );
};

export default ProductIntakes;
